import { GoogleTagManager, GtmNoscript } from 'tracking';
import { VirtualPageviewTracker } from './GTM/components/VirtualPageviewTracker';
import { GTM_ID_JPGROUP, GTM_ID_HOVWDIAUDI, GTM_SRC_JPGROUP, GTM_SRC_HOVWDIAUDI } from '~/shared/utils/public-variables';
import { isJPG } from 'utils';

const isJPGroup = isJPG();

type TrackingProps = {
  pageType?: string;
}

export const Tracking = ({ pageType }: TrackingProps) => {
  const gtmId = isJPGroup ? GTM_ID_JPGROUP : GTM_ID_HOVWDIAUDI;
  const gtmSrc = isJPGroup ? GTM_SRC_JPGROUP : GTM_SRC_HOVWDIAUDI;

  return (
    <>
      <VirtualPageviewTracker pageType={pageType} />
      <GtmNoscript gtmId={gtmId} />
      <GoogleTagManager gtmId={gtmId} src={gtmSrc} />
    </>
  );
};
